import React from 'react'
import { SUMMARY_ITEMS } from '../../data/parentNotificationData'
import { getParentNotificationIcon } from '../../data/parentNotificationIcons'
import s from './SummaryGrid.module.scss'

export const SummaryGrid = ({ activeCount, pausedCount }) => {
	const values = { activeCount, pausedCount }

	return (
		<div className={s.summary} aria-label="Configured update summary">
			{SUMMARY_ITEMS.map(item => {
				const Icon = getParentNotificationIcon(item.iconKey)
				const value = values[item.valueKey]

				return (
					<div key={item.id} className={s.summary__item}>
						<span className={s.summary__icon}>
							<Icon aria-hidden />
						</span>
						<span className={s.summary__copy}>
							<small className={s.summary__label}>{item.label}</small>
							<strong className={s.summary__value}>{value}</strong>
						</span>
					</div>
				)
			})}
		</div>
	)
}

export default SummaryGrid
